import { render, staticRenderFns } from "./EipCollapse.vue?vue&type=template&id=be1a6584&"
import script from "./EipCollapse.vue?vue&type=script&lang=js&"
export * from "./EipCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports